import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { QuestionProps } from '@/app/models/question'
import Accordion from '../../../Layout/Accordion/Accordion'
import { TaskProps } from '@/app/models/task'
import Question from '@/app/components/UI/Question/Question'
import { isMobileChecker } from '@/app/utils/commonFunctions'
import './Tasks.scss'
import { setQuestionStatus } from '@/app/utils/newActivityQuestionsStatus'
import { getTaskProgress } from '@/app/utils/getTaskProgress'
import { AttachmentProps } from '@/app/models/attachment'
import Attachment from '@/app/components/UI/Attachment/Attachment'
import { Markup } from 'interweave'

const Tasks = (props: {
    tasks: TaskProps[]
    setTasks: (tasks: TaskProps[]) => void
    answerQuestion: (
        projectId: string,
        questionId: string,
        answer: any,
        jobId?: string,
        answerAttachments?: any[]
    ) => void
    taskCreationDate?: any
    setTaskCreationDate?: any
}) => {
    const { tasks, setTasks, answerQuestion, taskCreationDate, setTaskCreationDate } = props

    const intl = useIntl()

    const isMobile = isMobileChecker()

    const componentClass = 'smart-modals-news-execution-tasks'

    useEffect(() => {
        const newTasks = getTaskProgress(tasks, setQuestionStatus)
        // set tasks finale
        setTasks(newTasks)
    }, [])

    const onUpdateAnswer = (a: any, q: QuestionProps, t: TaskProps) => {
        answerQuestion(q.projectId, q._id, a, t._id, q.answerAttachments)
        let tmpTasks: TaskProps[] = [...tasks]
        let newTasks: TaskProps[] = []
        for (let i = 0; i < tmpTasks.length; i++) {
            let tmpTask = tmpTasks[i]
            if (tmpTask.id === t.id) {
                let tmpTaskQuestions: QuestionProps[] = tmpTask.questions
                let newTaskQuestions: QuestionProps[] = []
                for (let x = 0; x < tmpTaskQuestions.length; x++) {
                    let tmpTaskQuestion = tmpTaskQuestions[x]
                    if (tmpTaskQuestion.id === q.id) {
                        newTaskQuestions.push({ ...tmpTaskQuestion, answer: a })
                    } else {
                        newTaskQuestions.push(tmpTaskQuestion)
                    }
                }
                newTasks.push({
                    ...tmpTask,
                    questions: [...newTaskQuestions],
                })
            } else {
                newTasks.push(tmpTask)
            }
        }
        // check to define status completed or not_completed
        newTasks = getTaskProgress(newTasks, setQuestionStatus)
        // set tasks finale
        if (new Date(t.creation_date).getTime() <= new Date().getTime()) {
            setTasks(newTasks)
        }
    }

    useEffect(() => {
        let tmp = []

        tasks.map((elem) => {
            tmp.push({ startDate: elem.creation_date, _id: elem._id })
        })

        setTaskCreationDate(tmp)
    }, [tasks])

    const onUpload = (files, q: QuestionProps, t: TaskProps) => {
        let tmpTasks: TaskProps[] = [...tasks]
        let newTasks: TaskProps[] = []
        let newQuestion: QuestionProps
        for (let i = 0; i < tmpTasks.length; i++) {
            let tmpTask = tmpTasks[i]
            if (tmpTask.id === t.id) {
                let tmpTaskQuestions: QuestionProps[] = tmpTask.questions
                let newTaskQuestions: QuestionProps[] = []
                for (let x = 0; x < tmpTaskQuestions.length; x++) {
                    let tmpTaskQuestion = tmpTaskQuestions[x]
                    if (tmpTaskQuestion.id === q.id) {
                        newQuestion = {
                            ...tmpTaskQuestion,
                            answerAttachments: [
                                ...q.answerAttachments,
                                ...files.map((file: any) => ({
                                    file: file.file,
                                    url: file.url,
                                    id: file.id,
                                }))
                            ],
                        }
                        newTaskQuestions.push(newQuestion)
                    } else {
                        newTaskQuestions.push(tmpTaskQuestion)
                    }
                }
                newTasks.push({
                    ...tmpTask,
                    questions: newTaskQuestions,
                })
            } else {
                newTasks.push(tmpTask)
            }
        }
        // check on tasks status
        newTasks = newTasks.map((t: TaskProps) => {
            let check = true
            let questions = t?.questions
            if (questions?.length) {
                questions = questions.map((q: QuestionProps) => {
                    let status = 'completed'
                    if (q.answer !== '' && !q.attachmentsRequired) {
                        status = 'completed'
                    } else if (
                        (!q.answer || q.answer === '') &&
                        !q.attachmentsRequired &&
                        q.answerAttachments?.length > 0
                    ) {
                        status = 'completed'
                    } else if (
                        q.answer !== '' &&
                        q.attachmentsRequired &&
                        q.answerAttachments?.length === 0
                    ) {
                        status = 'not_completed'
                    } else if (
                        (!q.answer || q.answer === '') &&
                        q.attachmentsRequired &&
                        q.answerAttachments?.length > 0
                    ) {
                        status = 'not_completed'
                    } else {
                        status = ''
                    }
                    return {
                        ...q,
                        status: status,
                    }
                })
                questions.map((q: QuestionProps) => {
                    if (q.status === '' || q.status === 'not_completed') {
                        check = false
                    }
                })
            }
            return {
                ...t,
                status: check ? 'completed' : '',
            }
        })
        // set tasks finale
        setTasks(newTasks)
        answerQuestion(q.projectId, q._id, q.answer, t._id, newQuestion.answerAttachments)
    }

    return (
        <>
            <div className={componentClass}>
                {isMobile && (
                    <div className={`${componentClass}__info`}>
                        <div className={`${componentClass}__info__number_of`}>
                            <span>{`${intl.formatMessage({
                                id: 'modals.news_execution.project_specs.details.number_of',
                                defaultMessage: 'Number of',
                            })} ${intl.formatMessage({
                                id: 'modals.news_execution.action.action_card.title.tasks',
                                defaultMessage: 'Tasks',
                            })}`}</span>
                            <strong>{tasks?.length}</strong>
                        </div>
                    </div>
                )}
                {tasks?.length > 0 ? (
                    tasks.map((t: TaskProps, i: number) => {
                        return (
                            <Accordion
                                id={i}
                                key={i}
                                title={t.title}
                                activeIndex={i}
                                className={t.status}
                                progress={t.progress}
                                taskCreationDate={taskCreationDate}>
                                <div className={`${componentClass}__task`}>
                                    <div className={`${componentClass}__task__details`}>
                                        <div className={`${componentClass}__task__details__detail`}>
                                            <strong>
                                                {intl.formatMessage({
                                                    id: 'modals.news_execution.action.tasks.detail.creation_date',
                                                    defaultMessage: 'Creation date',
                                                })}
                                            </strong>
                                            <span>{t.creation_date}</span>
                                        </div>
                                        <div className={`${componentClass}__task__details__detail`}>
                                            <strong>
                                                {intl.formatMessage({
                                                    id: 'modals.news_execution.action.tasks.detail.end_date',
                                                    defaultMessage: 'End date',
                                                })}
                                            </strong>
                                            <span>{t.end_date}</span>
                                        </div>
                                        <div className={`${componentClass}__task__details__detail`}>
                                            <strong>
                                                {intl.formatMessage({
                                                    id: 'modals.news_execution.action.tasks.detail.priority',
                                                    defaultMessage: 'Priority',
                                                })}
                                            </strong>
                                            <span>{t.priority}</span>
                                        </div>
                                        <div className={`${componentClass}__task__details__detail`}>
                                            <strong>
                                                {intl.formatMessage({
                                                    id: 'modals.news_execution.action.tasks.detail.role',
                                                    defaultMessage: 'Role',
                                                })}
                                            </strong>
                                            <span>{t.role}</span>
                                        </div>
                                        {t.questions?.length > 0 && (
                                            <div
                                                className={`${componentClass}__task__details__detail`}>
                                                <strong>
                                                    {intl.formatMessage({
                                                        id: 'modals.news_execution.action.tasks.detail.questions',
                                                        defaultMessage: 'Questions',
                                                    })}
                                                </strong>
                                                <span>{t.questions.length}</span>
                                            </div>
                                        )}
                                    </div>
                                    {t.attachments && (
                                        <div className={`${componentClass}__attachments`}>
                                            {t.attachments.map((a: AttachmentProps, i: number) => {
                                                return (
                                                    <div key={i}>
                                                        {a && (
                                                            <Attachment
                                                                key={i}
                                                                fileUrl={a?.url}
                                                                fileName={a?.name}
                                                                fileExtension={a?.ext}
                                                                showDownloadIcon
                                                            />
                                                        )}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                    {t?.questions && (
                                        <div className={`${componentClass}__task__subtasks`}>
                                            {t.questions?.length > 0 &&
                                                t.questions?.map((q: QuestionProps, i2: number) => {
                                                    return (
                                                        <Accordion
                                                            key={i2}
                                                            activeIndex={i2}
                                                            title={q.question}
                                                            className={`subtask`}>
                                                            <div
                                                                className={`${componentClass}__task__subtasks__subtask`}>
                                                                {q?.questionTitle && (
                                                                    <div
                                                                        className={`${componentClass}__task__subtasks__subtask__paragraph`}>
                                                                        <Markup
                                                                            content={
                                                                                q.questionTitle
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div
                                                                    className={`${componentClass}__task__subtasks__subtask__questions`}>
                                                                    <Question
                                                                        key={i2}
                                                                        task={t}
                                                                        question={q}
                                                                        onUpload={onUpload}
                                                                        onUpdateAnswer={
                                                                            onUpdateAnswer
                                                                        }
                                                                        isJobQuestion={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Accordion>
                                                    )
                                                })}
                                        </div>
                                    )}
                                </div>
                            </Accordion>
                        )
                    })
                ) : (
                    <div>
                        {intl.formatMessage({
                            id: 'modals.news_execution.action.tasks.no_tasks',
                            defaultMessage: 'No tasks.',
                        })}
                    </div>
                )}
            </div>
        </>
    )
}

export default Tasks
